<template>
    <svg height="17.072" viewBox="0 0 17.072 17.072" width="17.072" xmlns="http://www.w3.org/2000/svg">
        <g id="Group_2637" data-name="Group 2637" transform="translate(-1774.717 -208.439)">
            <g id="Group_2633" data-name="Group 2633">
                <g id="Icon_feather-clock" data-name="Icon feather-clock" transform="translate(1772.567 206.289)">
                    <path
                        id="Path_2211"
                        d="M18.372,10.686A7.686,7.686,0,1,1,10.686,3a7.686,7.686,0,0,1,7.686,7.686Z"
                        data-name="Path 2211"
                        fill="none"
                        stroke="#3699ff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.7"
                        transform="translate(0 0)"
                    />
                    <path
                        id="Path_2212"
                        d="M18,9v4.612l3.074,1.537"
                        data-name="Path 2212"
                        fill="none"
                        stroke="#3699ff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.7"
                        transform="translate(-7.314 -2.926)"
                    />
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "Away",
};
</script>
